<div class="flex justify-between">
  <div class="prose">
    <h1>Cart</h1>
  </div>
</div>

<div class="flex">
  @if (errorFetchingInvoice) {
    <div class="text-error">
      <p>{{ errorFetchingInvoice }}</p>
    </div>
  } @else if (loadingInvoice || fetchingProductVariantDurations) {
    <div class="w-full text-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else if (!invoice && licenseList.length == 0) {
    <div class="w-full">
      <p class="my-5 text-xl font-bold">
        Your cart is empty, go to
        <a
          class="link-primary underline underline-offset-4"
          [routerLink]="['/licenses']"
          >Licenses</a
        >
        to add them to your cart.
      </p>
      <!-- <button class="btn btn-neutral" [routerLink]="['/licenses']">
        Go to Licenses
      </button> -->
    </div>
  } @else if (invoice && licenseList.length >= 1) {
    <div class="w-full">
      <div class="flex flex-col">
        @for (el of licenseList; track el) {
          <div
            class="relative w-full border-base-content/50 px-4 py-8 [&:not(:first-child)]:border-t"
          >
            @if (el.deleting || el.changingDuration) {
              <div class="z-2 absolute inset-0 bg-base-200/70">
                <div class="flex h-full items-center justify-center">
                  <div class="loading loading-spinner loading-lg"></div>
                </div>
              </div>
            }
            <div class="mb-2 flex justify-between">
              <p class="text-xl sm:text-2xl">
                {{ el.details.license_with_product.product.title }}
              </p>

              <p class="text-lg font-bold">
                {{ el.details.base_amount | currency: 'USD' }}
              </p>
            </div>
            <div class="mb-6 flex space-x-2">
              <p>
                <span class="mr-2">Type:</span>
                {{ getLicenseType(el.details.license_with_product) }}
              </p>
              <div class="divider divider-horizontal"></div>
              <p>
                <span class="mr-2">Duration:</span>
                {{
                  el.details.license_with_product.product_variant
                    .display_duration
                }}
              </p>
              <div class="divider divider-horizontal"></div>
              <p>
                <span class="mr-2">New Expiration:</span>
                {{
                  el.details.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                }}
              </p>
            </div>

            <div>
              <div
                class="mt-6 flex flex-col space-y-2 sm:flex-row sm:space-x-8 sm:space-y-0"
              >
                @for (
                  variant of el.variantOptions;
                  track variant.product_variant.id
                ) {
                  <div
                    class="relative flex cursor-pointer rounded-md border border-base-content px-4 py-2"
                    [ngClass]="{
                      'border-success bg-success/10': variant.selected,
                      indicator:
                        hasThreeYearOption(el) &&
                        variant.product_variant.duration_months === 36,
                    }"
                    (click)="updateLicenseDurationVariant(el, variant)"
                  >
                    @if (
                      hasThreeYearOption(el) &&
                      variant.product_variant.duration_months === 36
                    ) {
                      <span
                        class="badge indicator-item indicator-center h-8 rounded-md text-lg font-semibold shadow"
                        [ngClass]="{
                          'badge-success': variant.selected,
                          'badge-primary': !variant.selected,
                        }"
                      >
                        Best Value
                      </span>
                    }
                    <div
                      class="flex min-w-32 grow flex-col items-center"
                      [ngClass]="{
                        'mt-2': hasThreeYearOption(el),
                      }"
                    >
                      <p
                        class="mb-1 text-lg font-medium sm:text-2xl sm:font-normal"
                      >
                        {{ variant.product_variant.display_duration }}
                      </p>

                      <div
                        class="flex flex-col items-center justify-center text-sm"
                      >
                        <p class="text-base sm:text-lg">
                          {{ variant.cost | currency: 'USD' }}
                        </p>

                        @if (variant.cost_savings) {
                          <p class="mb-1 text-base italic">
                            (Save&nbsp;{{
                              variant.cost_savings.percent_discount
                            }}%)
                          </p>
                        }
                      </div>

                      @if (variant.new_expiration) {
                        <p class="mt-auto text-sm">
                          Exp:
                          {{
                            variant.new_expiration | date: 'MM/dd/yyyy' : 'UTC'
                          }}
                        </p>
                      }
                    </div>
                  </div>
                }

                <!-- <div
                class="cursor-pointer rounded-md border border-base-content px-4 py-2"
                [ngClass]="{
                  'border-error bg-error/10': el.remove,
                }"
                (click)="removeLicense(el)"
              >
                <div class="flex h-full min-w-32 flex-col items-center">
                  <p class="mb-1 text-lg">Do Not Renew</p>

                  <p class="mt-auto text-sm">
                    Exp:
                    {{
                      el.details.license_with_product.expiration
                        | date: 'MM/dd/yyyy' : 'UTC'
                    }}
                  </p>
                </div>
              </div> -->
              </div>
              <!-- <div class="flex justify-center">
                  <div class="btn btn-primary btn-sm">Confirm</div>
                </div> -->
            </div>

            <div class="mt-6 flex">
              <button
                class="btn btn-outline btn-sm"
                (click)="deleteLicense(el)"
                [disabled]="deletingLicense || changingLicenseDuration"
              >
                Delete
              </button>
            </div>

            @if (el.errorChangingDuration) {
              <div class="mt-6 text-center text-error">
                {{ el.errorChangingDuration }}
              </div>
            }
          </div>
        }
      </div>

      <div class="border-t border-base-content/50">
        <div class="flex justify-between pt-4 text-lg">
          <p class="ml-4">
            Go to
            <a
              class="link-primary underline underline-offset-4"
              [routerLink]="['/licenses']"
              >Licenses</a
            >
            to add more to your cart.
          </p>
          <!-- <div class="ml-4 flex items-center">
            <button class="btn btn-outline btn-sm" [routerLink]="'/licenses'">
              <app-plus-icon class="h-5 w-5"></app-plus-icon>
              Add More Licenses
            </button>
          </div> -->
          <div class="flex justify-end">
            <p class="mr-4">Subtotal:</p>
            <p class="pr-4 font-bold">
              {{ invoice.desktop_invoice.base_amount | currency: 'USD' }}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-8 w-full space-x-8 text-center">
        <button class="btn btn-primary" (click)="goToCheckout()">
          Proceed to Checkout
        </button>
      </div>
      @if (savingChanges) {
        <div class="mt-8 w-full text-center">
          <div class="loading loading-lg"></div>
        </div>
      }
      @if (errorSavingChanges) {
        <div class="mt-8 w-full text-center text-error">
          {{ errorSavingChanges }}
        </div>
      }
    </div>
  } @else {
    <div class="mt-8">
      <p class="italic">Cart is currently empty</p>
    </div>
  }
</div>

<!-- <dialog #removeChildrenModal class="modal">
  <div class="modal-box max-w-3xl p-8">
    <h3 class="text-lg font-bold">Confirm License Removal</h3>
    <p class="mt-4 text-sm">
      The license you are removing has the following site or add-on licenses.
      Removing this license will also remove the licenses below.
    </p>

    <div class="my-4">
      <table class="table table-zebra">
        <thead class="text-sm">
          <tr>
            <th class="font-medium">Product</th>
            <th class="font-medium">Type</th>
            <th class="font-medium">Price</th>
            <th class="font-medium">New Expiration</th>
          </tr>
        </thead>
        <tbody>
          @for (el of currentChildLicensesToRemove; track el) {
            <tr>
              <td>
                <div class="h-full w-full">
                  <span>
                    {{ el.details.license_with_product.product.title }}
                  </span>
                </div>
              </td>
              <td>
                {{
                  el.details.license_with_product.site_license ? 'Site' : 'Main'
                }}
              </td>
              <td>{{ el.details.total_amount | currency: 'USD' }}</td>
              <td>
                {{
                  el.details.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <p class="mt-4 text-sm text-error">
      Are you sure you want to remove this license along with all of its
      site/add-on licenses?
    </p>

    <div class="modal-action">
      <button class="btn btn-error" (click)="removeCurrentChildLicenses()">
        Remove Licenses
      </button>
      <button class="btn btn-neutral" (click)="cancelRemoveChildLicenses()">
        Cancel
      </button>
    </div>
  </div>
</dialog> -->

<!-- <dialog #addParentsModal class="modal">
  <div class="modal-box max-w-3xl p-8">
    <h3 class="text-lg font-bold">Confirm Undo Removal</h3>
    <p class="mt-4 text-sm">
      The license you are adding has the following parent licenses which are not
      active. You will need to re-add these parent licenses if you want to
      continue adding this license.
    </p>

    <div class="my-4">
      <table class="table table-zebra">
        <thead class="text-sm">
          <tr>
            <th class="font-medium">Product</th>
            <th class="font-medium">Type</th>
            <th class="font-medium">Price</th>
            <th class="font-medium">New Expiration</th>
          </tr>
        </thead>
        <tbody>
          @for (el of currentParentLicensesToAdd; track el) {
            <tr>
              <td>
                <div class="h-full w-full">
                  <span>
                    {{ el.details.license_with_product.product.title }}
                  </span>
                </div>
              </td>
              <td>
                {{
                  el.details.license_with_product.site_license ? 'Site' : 'Main'
                }}
              </td>
              <td>{{ el.details.total_amount | currency: 'USD' }}</td>
              <td>
                {{
                  el.details.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <p class="mt-4 text-sm text-error">
      Are you sure you want to add this license along with the parent licenses
      above?
    </p>

    <div class="modal-action">
      <button class="btn btn-error" (click)="addCurrentParentLicenses()">
        Add Licenses
      </button>
      <button class="btn btn-neutral" (click)="cancelAddParentLicenses()">
        Cancel
      </button>
    </div>
  </div>
</dialog> -->

<!-- <dialog #confirmChangesModal class="modal">
  <div class="modal-box max-w-3xl p-8">
    <h3 class="text-lg font-bold">Confirm License Changes</h3>

    @if (licensesToRemove.length > 0) {
      <p class="mt-4 text-sm">
        The licenses below will be removed from this invoice. This change is
        permanent.
      </p>

      <div class="my-4">
        <table class="table table-zebra">
          <thead class="text-sm">
            <tr>
              <th class="font-medium">Product</th>
              <th class="font-medium">Type</th>
              <th class="font-medium">New Expiration</th>
            </tr>
          </thead>
          <tbody>
            @for (el of licensesToRemove; track el) {
              <tr>
                <td>
                  <div class="h-full w-full">
                    <span>
                      {{ el.details.license_with_product.product.title }}
                    </span>
                  </div>
                </td>
                <td>
                  {{
                    el.details.license_with_product.site_license
                      ? 'Site'
                      : 'Main'
                  }}
                </td>
                <td>
                  {{
                    el.details.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC'
                  }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (
      licensesWithDurationChanges && licensesWithDurationChanges.length > 0
    ) {
      <p class="mt-8 text-sm">
        The licenses below will be updated to the new duration.
      </p>

      <div class="my-4">
        <table class="table table-zebra">
          <thead class="text-sm">
            <tr>
              <th class="font-medium">Product</th>
              <th class="font-medium">Type</th>
              <th class="font-medium">New Duration</th>
            </tr>
          </thead>
          <tbody>
            @for (el of licensesWithDurationChanges; track el) {
              <tr>
                <td>
                  <div class="h-full w-full">
                    <span>
                      {{ el.details.license_with_product.product.title }}
                    </span>
                  </div>
                </td>
                <td>
                  {{
                    el.details.license_with_product.site_license
                      ? 'Site'
                      : 'Main'
                  }}
                </td>
                <td>
                  {{ getDurationString(getSelectedVariant(el)!) }}
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="4">No licenses to update</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <div class="modal-action">
      <button class="btn btn-error" (click)="saveChanges()">
        Confirm Changes
      </button>
      <button class="btn btn-neutral" (click)="closeConfirmChangesModal()">
        Cancel
      </button>
    </div>
  </div>
</dialog> -->

<!-- <dialog #cannotRemoveAllModal class="modal">
  <div class="modal-box max-w-xl p-8">
    <h3 class="text-xl font-bold">Cannot Remove All Licenses</h3>
    <p class="my-4">
      Saving these changes would remove all licenses from this invoice which is
      not allowed. Please make sure that at least one license remains.
    </p>
    <p class="my-4">
      If you don't wish to renew any licenses, you can disregard this invoice.
    </p>

    <div class="modal-action justify-center">
      <button class="btn btn-primary" (click)="closeCannotRemoveAllModal()">
        Ok
      </button>
    </div>
  </div>
</dialog> -->
